/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "subtractedValue",
                type: "uint256",
            },
        ],
        name: "decreaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256",
            },
        ],
        name: "getWalletByShare",
        outputs: [
            {
                internalType: "address",
                name: "wallet",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "addedValue",
                type: "uint256",
            },
        ],
        name: "increaseAllowance",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "minter",
                type: "address",
            },
            {
                internalType: "bool",
                name: "isMinter",
                type: "bool",
            },
        ],
        name: "setMinter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class BTLY__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
BTLY__factory.bytecode = _bytecode;
BTLY__factory.abi = _abi;
